// ChangePipelineView.js

import React from 'react';

const ChangePipelineView = () => {
  return <div>??? Change Pipeline is coming soon...</div>;
};

export default ChangePipelineView;
